import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslationService } from '@sdbn/common';
import { TmcContextService } from 'src/tmc-common/services/tmc-context.service';
import { DataProtectionRule } from 'src/tmc-yard/client/model/data-protection-rule';


@Component({
  selector: 'app-data-protection-field',
  templateUrl: './data-protection-field.component.html',
  styleUrls: ['./data-protection-field.component.scss']
})
export class DataProtectionFieldComponent implements OnInit {

  @Input() label!: string;

  @Input() required: boolean = false;

  @Input() grow: boolean;

  public readonly formControl = new FormControl(null, []);

  dataProtectionRules = new Array<DataProtectionRule>();

  constructor(
    public translationService: TranslationService,
    private tmcContextService: TmcContextService,
  ) { }

  ngOnInit(): void {
    this.tmcContextService.updated.subscribe(
      () => {
        this.dataProtectionRules = this.tmcContextService.getYardConfiguration().dataProtectionRules;
      }
    );
    this.formControl.valueChanges
      .subscribe(() => {
        const value = this._getValue();
        this._onChange(value);
      });
  }

  /** Return a Date if the fields are ready or null otherwise */
  private _getValue(): number | null {
    try {
      if (this.formControl.invalid) {
        return null;
      }

      return this.formControl.value;
    } catch {
      // Return null if something throws
      return null;
    }
  }

  public writeValue(value: number | null): void {
    console.log('value is set as', value);
    if (value != null) {
      this.formControl.setValue(value);
    } else {
      this.formControl.setValue(null);
    }
  }

  private _onChange = (_value: number | null): void => undefined;
  public registerOnChange(fn: (value: number | null) => void): void {
    this._onChange = fn;
  }

  /** It's called in the component template when we have a "blur" or "input" event */
  public onTouched = (): void => undefined;
  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.formControl.disable();
    } else {
      this.formControl.enable();
    }
  }


}
